<template>
  <v-card class="bordered-card import-company">
    <input type="file" @change="() => handleFile('pick')" accept=".csv" ref="csvImport" style="display: none"/>
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        Add Company
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="results.length" color="primary" @click="saveImported" :loading="btnLoading" :disabled="btnLoading">
        Save
      </v-btn>
      <v-btn @click="pickFile" color="secondary" :loading="loadingCSV" :disabled="loadingCSV">
        Import CSV
      </v-btn>
      <!-- </v-toolbar-items> -->
    </v-toolbar>
    <v-alert
      :type="alert.type"
      v-model="alert.status"
      dismissible
    >
      {{alert.message}}
    </v-alert>
    <v-card-text>
      <v-layout row wrap>
        <v-flex sm12 xs12 v-if="results.length">
          <v-data-table
            :headers="headers"
            :items="results"
            :rows-per-page-items="[15, 25, 50, 100]"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.companylegalname || 'N/A' }}</td>
              <td class="text-xs-left">{{ props.item.companydescription || 'N/A' }}</td>
              <td class="text-xs-left">{{ props.item.emailaddress || 'N/A' }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  // import papaparse from 'papaparse'
  import axios from 'axios'

  export default {
    data () {
      return {
        droppedFiles: null,
        dragOver: false,
        sendEmails: false,
        sendingEmail: false,
        alert: {
          status: false,
          message: '',
          type: 'warning'
        },
        loadingCSV: false,
        btnLoading: false,
        results: [],
        headers: [
          {
            text: 'Company Name',
            align: 'left',
            sortable: false,
            value: 'companylegalname'
          },
          {
            text: 'Company Description',
            align: 'left',
            sortable: false,
            value: 'companydescription'
          },
          {
            text: 'Email Address',
            align: 'left',
            sortable: false,
            value: 'emailaddress'
          }
        ]
      }
    },
    methods: {
      pickFile () {
        this.$refs.csvImport.click()
      },
      handleFile (type = 'pick') {
        this.alert.status = false
        this.dragOver = false
        this.alert.status = false
        this.results = []
        let file
        if (type === 'drop') {
          file = this.droppedFiles[0]
        } else if (type === 'pick') {
          file = this.$refs.csvImport.files[0]
        }

        if (file) {
          if (file.type.indexOf('csv') < 0) {
            this.alert = {
              type: 'error',
              status: true,
              message: 'Please upload a valid CSV file.'
            }
            return
          }

          this.loadingCSV = true

          return window.Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            greedy: true,
            worker: true,
            preview: 100,
            complete: (results) => {
              this.loadingCSV = false
              if (results.data.length > 100) {
                this.alert = {
                  type: 'error',
                  status: true,
                  message: 'Required limit: You can only import 100 items at a time'
                }
                return
              }
              if (!results.meta.fields.includes('companylegalname') || !results.meta.fields.includes('dunsnumber')) {
                this.alert = {
                  type: 'error',
                  status: true,
                  message: 'Please upload a valid CSV file with the accepted headers. companylegalname, dunsnumber'
                }
              }

              this.results = this._.map(results.data, (v) => {
                var omitted = this._.omit(v, ['_id', 'id'])
                var transformed = this._.mapValues(omitted, function (fieldValue) {
                  if (fieldValue === 'TRUE') {
                    return true
                  } else if (fieldValue === 'FALSE') {
                    return false
                  } else {
                    return fieldValue
                  }
                })
                return transformed
              }).filter(val => {
                return val.companylegalname
              }).map(val => {
                return {
                  ...val,
                  datasource: 'Exchange_app',
                  dirviewable: val.dunsnumber.length === 9
                }
              })
            }
          })
        }
      },
      saveImported () {
        this.btnLoading = true
        const uri = 'https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?checkclientid=false'
        return axios
          .post(uri, this.results)
          .then(res => {
            this.btnLoading = false
            this.alert = {
              type: 'success',
              status: true,
              message: 'Companies imported successfully.'
            }
          })
          .catch(() => {
            this.btnLoading = false
            this.alert = {
              type: 'error',
              status: true,
              message: 'Something went wrong while saving the contacts.'
            }
          })
      },
      resetForm () {
        this.btnLoading = false
        this.companyForm = {
          companylegalname: null,
          emailaddress: null,
          addressline1: null,
          addressline2: null,
          city: null,
          county: null,
          latitude: null,
          longitude: null,
          state: null,
          zip: null
        }
        this.results = []
      }
    }
  }
</script>
<style>
  .import-company .input-group--select {
    margin-top: initial !important;
  }
  .form-layout .flex {
    padding: 4px;
  }
  .manual-add {
    height: 400px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .manual-add .dot-border {
    width: 700px;
    height: 300px;
    padding: 90px;
    /* display: flex;
    justify-content: center;
    align-items: center; */
    background-color: #fbfbfc;
    border: 1px dashed #d4dadf;
  }
  .manual-add .dot-border.primary {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// ImportCompany.vue?a837fa12